import React, { useEffect, useState } from "react";
import { Modal, Button } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { WarningOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { CheckCircleOutlined } from "@ant-design/icons";

// import "./qsetdashboardevalcard.scss";

function NuJobsMyEvalsCard({ evalItem }) {
  const qsetUserDetails = JSON.parse(localStorage.getItem("qsetUserDetails"));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  console.log("evalItem", evalItem);
  const handleTsToDate = (value) => {
    const eDay = new Date(value * 1000);
    return eDay.toDateString();
  };
  const handleTsToTime = (value) => {
    const eDay = new Date(value * 1000);
    return eDay.toLocaleTimeString();
  };
  const handleOnClick = () => {
    navigate(`/qsethome/qsetjd`);
  };

  const handleStartTest = () => {
    var ev_id = evalItem.qhevid;
    navigate(`/nujobshome/nujobsEvaluations/readyPage/${ev_id}`);
  };

  const handleViewEvalResults = () => {
    var ev_id = evalItem.id;
    navigate(`/nujobshome/nujobsMyEvals/${ev_id}`);
  };

  console.log("evalItem in nujobsc ard", evalItem);
  const EvalStatus = {
    Pending: (
      <>
        <Button
          className="apply-button"
          disabled={evalItem?.evalstatus === "Completed"}
          onClick={handleStartTest}
        >
          Start Test
        </Button>
        <span className="company-name">
          <span className="eval-detail-item eval-expires">Created On:</span>
          <span className="eval-detail-item eval-expires">
            {/* {evalItem?.createdby.updatedon} */}
          </span>
        </span>
      </>
    ),
    "Proctoring Fail": (
      <>
        <div className="result-info-warning">
          <span className="info-warning">
            <WarningOutlined />
          </span>{" "}
          Proctoring terminated after repeated violations.
        </div>
        <p className="contact-info">Please contact HR for more information.</p>
      </>
    ),

    Completed: (
      <>
        <div className="result-info-completed">
          <span className="info-completed">
            <CheckCircleOutlined />
          </span>{" "}
          Completed
        </div>
        {/* <p className="contact-info">HR will contact you soon.</p> */}
      </>
    ),
  };

  return (
    <div className="eval-card" onClick={handleViewEvalResults}>
      <div className="eval-card-header">
        <div className="eval-title">{evalItem.generalsetting?.name}</div>
        <div className="eval-title1">
          Result:{" "}
          {evalItem?.result?.[1]?.percentage ??
            evalItem?.result?.[0]?.percentage}
          %
        </div>
      </div>
      <div className="eval-duration">
        <ClockCircleOutlined /> {evalItem?.duration} mins
      </div>
      <div className="eval-details">
        {evalItem.skillarray?.map((skillItem, idx) => (
          <span className="eval-detail-item eval-skill">
            {skillItem.skill.toUpperCase()}
          </span>
        ))}
      </div>
      {EvalStatus[evalItem?.evalstatus ? evalItem?.evalstatus : "Completed"]}
    </div>
  );
}

export default NuJobsMyEvalsCard;
